//  icons
import {
  FiYoutube,
  FiInstagram,
  FiGithub,
  FiDribbble,
  FiLinkedin,
  FiLayout,
  FiSettings,
  FiPenTool,
  FiTag,
  FiMail,
  FiMapPin,
} from 'react-icons/fi';

// companies icons
import FreelancerBrandIcon from './assets/img/brands/freelancer.png';
import UpworkBrandIcon from './assets/img/brands/upwork.png';
import FiverBrandIcon from './assets/img/brands/fiverr.png';
import BehanceBrandIcon from './assets/img/brands/behance.png';
import DribbbleBrandIcon from './assets/img/brands/dribbble.png';

// projects images
import Project1 from './assets/img/projects/f1.png';
import Project11 from './assets/img/projects/f11.png';
import Project12 from './assets/img/projects/f12.png';
import Project2 from './assets/img/projects/f2.png';
import Project21 from './assets/img/projects/f21.png';
import Project22 from './assets/img/projects/f22.png';
import Project3 from './assets/img/projects/f3.png';
import Project31 from './assets/img/projects/f31.png';
import Project32 from './assets/img/projects/f32.png';
import Project4 from './assets/img/projects/f4.png';
import Project41 from './assets/img/projects/f41.png';
import Project42 from './assets/img/projects/f42.png';
import Project5 from './assets/img/projects/f5.png';
import Project51 from './assets/img/projects/f51.png';
import Project52 from './assets/img/projects/f52.png';
import Project6 from './assets/img/projects/f6.png';
import Project61 from './assets/img/projects/f61.png';
import Project62 from './assets/img/projects/f62.png';



// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
import SkillImg5 from './assets/img/skills/wordpress.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg8 from './assets/img/skills/figma.png';

// testimonial images
import TestiImage1 from './assets/img/testimonials/testimonial-1.webp';
import TestiImage2 from './assets/img/testimonials/testimonial-2.webp';
import TestiImage3 from './assets/img/testimonials/testimonial-3.webp';

// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'portfolio',
    href: 'portfolio',
  },
  {
    name: 'services',
    href: 'services',
  },
  {
    name: 'testimonials',
    href: 'testimonials',
  },
  {
    name: 'contact',
    href: 'contact',
  },
];

// social
export const social = [
  {
    icon: <FiYoutube />,
    href: 'https://www.youtube.com/channel/UCP6KZuZMEIGriEF7X5PxrjA',
  },
  {
    icon: <FiInstagram />,
    href: 'https://www.instagram.com/alvi_himel/',
  },
  {
    icon: <FiGithub />,
    href: 'https://github.com/himelislam',
  },
  {
    icon: <FiLinkedin />,
    href: 'https://www.linkedin.com/in/himel-islam-337993229/',
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: '',
  },
  {
    img: UpworkBrandIcon,
    href: '',
  },
  {
    img: FiverBrandIcon,
    href: '',
  },
  {
    img: BehanceBrandIcon,
    href: '',
  },
  {
    img: DribbbleBrandIcon,
    href: '',
  },
];

// projects
export const projectsData = [
  {
    id: '1',
    image: Project1,
    image1: Project11,
    image2: Project12,
    name: 'Lukas Manufacture',
    category: 'Mern Stack',
    description: 'Lukas Manufacturer is a Car Parts Manufacturer based web application. It Provides a Dashboard for users and admins to do different  functionality.',
    li1: 'On Dashboard it has a add profile page where user can add their profile and also update their profile ',
    li2: 'On Dashboard it also has a My Orders page where user can see his order and can cancel it or can pay the order by clicking pay.',
    li3: 'On Dashboard it also has a add review page where user can a add review for the website.',
    li4: 'For Admins websites dashboard provides different pages called Manage Orders, Add Product, Make Admin, Manage Products. ',
    li5: 'My Profile can use both users and admins to add and update their profile.',
    liveSite : 'https://lucas-manufacturer.web.app/',
    githubClient: 'https://github.com/himelislam/lukas-manufacturer-client-site',
    githubServer: 'https://github.com/himelislam/lukas-manufacturer-server-site',
  },
  {
    id: '2',
    image: Project2,
    image1: Project21,
    image2: Project22,
    name: 'The Warehouse',
    category: 'Mern Stack',
    description: 'The Warehouse is an inventory management website. It provides to manage inventory, update products, delete/ add products and quantity',
    li1: 'On Home page it has a Carousel Banner, Inventory Products section, Testimonials section, Our Partners secion and a Footer for all Pages ',
    li2: 'On Manage Item page user can see all products, and can delete, update, and select the product for my item page.',
    li3: 'On Add Item page user can add a new item to the inventory by fill up a form',
    li4: 'On Update Item page user can see products datails like sold amount, supplier etc and can delever a item by clicking delevered button, and can restock the product amount by using restock form',
    li5: 'User have to login or signup to use Manage Item, Add Item, Update Item and My Item page.',
    liveSite : 'https://the-warehouse-76732.web.app/',
    githubClient: 'https://github.com/himelislam/the-warehouse-client-site',
    githubServer: 'https://github.com/himelislam/the-warehouse-server-site',
  },
  {
    id: '3',
    image: Project3,
    image1: Project31,
    image2: Project32,
    name: 'Antic Agency',
    category: 'WordPress',
    description: 'Antic Agency is a marketing agency-based website built with WordPress. It provides different services like Website Design, Digital Branding, Online Branding, SEO Optimization',
    li1: ' It provides different services like Website Design, Digital Branding, Online Branding, SEO Optimization',
    li2: 'It has plans such as a Basic plan, Standard plan, and Advanced plan',
    li3: ' It also has a Blog section where users can see the relative blogs which might useful for them.',
    li4: ' They provide different types of online courses, users can purchase any course and make payment via Visa or Master card.',
    li5: ' It has a job portal section where users can post or find any job.',
    liveSite : 'https://dev-antic.pantheonsite.io/',
    githubClient: '',
    githubServer: '',
  },
  {
    id: '4',
    image: Project4,
    image1: Project41,
    image2: Project42,
    name: 'Jody Michael',
    category: 'React',
    description: ' Jay Michael Is Personal Career Coach Based web application. She Provides various services for personal development.',
    li1: 'It has 6 Routes regarding Login and Signup page',
    li2: 'Jay Michael provides career orianted coaching services',
    li3: 'It also has blog section named as Helpful Resources',
    li4: 'User have to Login or Signup for Book her services',
    li5: 'They can Create a new Account or Sign In with Google, Facebook or Github',
    liveSite : 'https://jody-michael.web.app/',
    githubClient: 'https://github.com/himelislam/jody-michael-coach',
    githubServer: '',
  },
  {
    id: '5',
    image: Project5,
    image1: Project51,
    image2: Project52,
    name: 'Blockchain Buddy',
    category: 'React',
    description: 'Blockchain Buddy is a Marketplace based Web Application. Here people review blockchain based currrency like bitcoin, ethereum and more.',
    li1: 'Blockchain Buddy is a Marketplace based Web Application.',
    li2: 'Its Build in React.js which is a Javascript library.',
    li3: 'Its still a Front-end project and used fakedata in public folder.',
    li4: 'Here people review blockchain based currrency like bitcoin, ethereum and more.',
    li5: 'It also has Dashboard section for some practice graph',
    liveSite : 'https://blockchainbuddy.netlify.app/',
    githubClient: 'https://github.com/himelislam/blockchain-buddy',
    githubServer: '',
  },
  {
    id: '6',
    image: Project6,
    image1: Project61,
    image2: Project62,
    name: 'Todo App',
    category: 'Mern Stack',
    description: 'Its a Todo app a time management based web application. Here user can add tasks and can delete after compliting it.',
    li1: 'Its a Time management based web application',
    li2: 'User needs to Signup or Google SignIn for use this application',
    li3: 'User can select his task and add this task for his task list',
    li4: 'He can delete his task from his task list',
    li5: 'Users can marked is as a complete button by clicking complete button',
    liveSite : 'https://todo-app-f3cd8.web.app/',
    githubClient: 'https://github.com/himelislam/todo-app',
    githubServer: 'https://github.com/himelislam/todo-app-server',
  },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'Mern Stack',
  },
  {
    name: 'WordPress',
  },
  {
    name: 'React',
  },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: 'Web Design',
    description:
      'I will create aesthetically pleasing, modern, and user-centric Web & Mobile App Designs. A success-driven professional working with startups to corporates helping them achieve their business goals.',
  },
  {
    icon: <FiSettings />,
    name: 'React Development',
    description:
      'Having an attractive Web App is very important so users spend most of their time on the Web only if its smooth, I do work with React and bootstrap for frontend. As I have more than three years of experience in website development (React JS) therefore I excel in developing creative designs.',
  },
  {
    icon: <FiPenTool />,
    name: 'WordPress Development',
    description:
      'A professional, eye-catching, highly interactive and mobile responsive website is guaranteed followed by 2 weeks free support to Kickstart Your Business',
  },
  {
    icon: <FiTag />,
    name: 'SEO',
    description:
      'I have worked in the digital marketing space, servicing clients domestically and internationally in my business, for the first time I am offering my full done for you SEO service to a limited audience per month at a drastically reduced rate',
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Antic Agency',
  },
  {
    authorImg: TestiImage2,
    authorText:
      'The best developer I have worked with on Fiverr. Very professional and clean code. Highly recommend and will continue to work with.',
    authorName: 'John Smith',
    authorPosition: 'Head of Marketing, Simpler',
  },
  {
    authorImg: TestiImage3,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'HR, Suffle',
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    description: 'Email me at himel7100@gmail.com',
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Sylhet, Bangladesh',
    description: 'Serving clients worldwide',
  },
];
